import { Col, Form, Input, Row, Tooltip } from "antd";
import { InfoCircleOutlined, LockOutlined } from "@ant-design/icons";

// Constants Library
import { ROOT_CONSTANT } from "../../../../constants";

const { icon_malaysia } = ROOT_CONSTANT.IMG.ICON.COUNTRY;

const CompanyInformation = ({ props }) => {
  const { type, readOnly } = props;

  return (
    <>
      <Row>
        <Col style={{ width: "100%", marginBottom: "10px" }}>
          <Form.Item>
            <Row
              style={{
                color: "#cacaca",
                alignItems: "center",
                fontSize: "15px",
              }}
            >
              <Col span={22} style={{ textAlign: "left", width: "100%" }}>
                Company Information
              </Col>
            </Row>
          </Form.Item>
        </Col>
      </Row>
      {type !== "Create" && (
        <Row>
          <Col style={{ width: "100%", marginBottom: "10px" }}>
            <label htmlFor="label" className="labelInput">
              Company ID <span style={{ color: "red" }}>*</span>
            </label>
            <Form.Item name="coid">
              <Input
                className="inputForm"
                suffix={<LockOutlined style={{ color: "#D9D9D9" }} />}
                readOnly
              />
            </Form.Item>
          </Col>
        </Row>
      )}
      <Row>
        <Col style={{ width: "100%", marginBottom: "10px" }}>
          <label htmlFor="label" className="labelInput">
            Company name <span style={{ color: "red" }}>*</span>
          </label>
          <Form.Item
            name="name"
            rules={[{ required: true, message: "Company Name is required" }]}
          >
            <Input className="inputForm" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col style={{ width: "100%", marginBottom: "10px" }}>
          <label htmlFor="label" className="labelInput">
            Company short code <span style={{ color: "red" }}>*</span>
          </label>
          <Form.Item
            name="short_code"
            rules={[
              { 
                required: true, 
                message: "short code is required" 
              },
              {
                pattern: /^[A-Z0-9]*$/,
                message: 'Short code must be uppercase letters and numbers only.',
              },
              {
                max: 10,
                message: 'Short code must be at most 10 characters long.',
              }
            ]}
          >
            <Input className="inputForm" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col style={{ width: "100%", marginBottom: "10px" }}>
          <label htmlFor="label" className="labelInput">
            Registration number <span style={{ color: "red" }}>*</span>
          </label>
          <Form.Item
            name="regis_number"
            rules={[{ required: true, message: "Company Name is required" }]}
          >
            <Input className="inputForm" readOnly={readOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col style={{ width: "100%", marginBottom: "10px" }}>
          <label htmlFor="label" className="labelInput">
            PIC name <span style={{ color: "red" }}>*</span>
            <Tooltip title="This PIC will be the main contact for billing.">
              <InfoCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                  marginLeft: "10px",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </label>
          <Form.Item
            name={["pic", "name"]}
            rules={[{ required: true, message: "Company Name is required" }]}
          >
            <Input className="inputForm" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <label htmlFor="contact" className="labelInput">
            PIC contact <span style={{ color: "red" }}>*</span>
          </label>
          <div
            className="inputForm"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "90%",
              marginRight: "8px",
              height: "42px",
            }}
          >
            <img
              src={icon_malaysia}
              alt="country"
              style={{ marginTop: "3px" }}
            />
            <span style={{ marginLeft: "7px", marginTop: "3px" }}>+60</span>
          </div>
        </Col>
        <Col span={16}>
          <Form.Item
            name={["pic", "contact"]}
            rules={[
              {
                required: true,
                message: "Contact is required",
              },
            ]}
          >
            <Input
              className="inputForm"
              maxLength="10"
              style={{ backgroundColor: "transparent" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CompanyInformation;
